import { createSlice } from "@reduxjs/toolkit";
import { getCarouselIndexFromNum } from "../../utils";

interface ICarousel {
  carouselNumber: number;
  carouselNumberForSpin: number;
  prevCarouselNumber: number;
}

const initialState: ICarousel = {
  carouselNumber: -1,
  carouselNumberForSpin: -1,
  prevCarouselNumber: -1,
};

export const carouselSlice = createSlice({
  name: "carousel",
  initialState,
  reducers: {
    setCarouselNumber: (state, { payload }) => {
      const carouselIndex = getCarouselIndexFromNum(payload);
      if (carouselIndex >= 0) {
        state.carouselNumber = carouselIndex;
      }
      state.carouselNumberForSpin = -1;
    },
    setCarouselNumberForSpin: (state) => {
      state.carouselNumberForSpin = state.carouselNumber;
    },
    setPrevCarouselNumber: (state, { payload }) => {
      state.prevCarouselNumber = payload;
    },
    clearAndSetCarouselNumber: (state) => {
      state.prevCarouselNumber = state.carouselNumber;
      state.carouselNumber = -1;
      state.carouselNumberForSpin = -1;
    },
  },
});

export const {
  setCarouselNumber,
  setCarouselNumberForSpin,
  setPrevCarouselNumber,
  clearAndSetCarouselNumber,
} = carouselSlice.actions;

export default carouselSlice.reducer;
